import { ASSIGNED_TASKS, MY_TASKS, MyTasksListKey } from "../../../redux/myTasks";

/** Copy shown in place of the list when a tab has nothing to show. */
export const TASK_EMPTY_STATE_TEXT: Record<MyTasksListKey, string> = {
  [MY_TASKS]: "You do not have any tasks assigned to you.",
  [ASSIGNED_TASKS]: "You have not assigned any tasks to your team.",
};
